@if (visible) {
  <div class="container cookie-consent_container">
    <div class="cookie-consent">
      <span>
        Этот сайт использует <b>cookie</b> для хранения данных. Продолжая
        использовать сайт, вы даете согласие на работу с этими файлами в
        соответствии с нашей
        <a href="https://www.x5.ru/ru/privacy-policy/" target="_blank"
          >Политикой</a
        >
      </span>
      <div class="cookie-consent_buttons">
        <button
          type="button"
          (click)="declineCookies()"
          class="btn btn-secondary"
        >
          Продолжить, не принимая
        </button>
        <button type="button" (click)="acceptCookies()" class="btn btn-primary">
          Да, согласен
        </button>
      </div>
    </div>
  </div>
}
